module.exports = __webpack_public_path__ + "fonts/TTNormsPro-Thin.e42377a2.woff2";